import classNames from 'classnames';
import styles from './Button.module.scss';

const Button = ({ action, children, type = [], disabled }) => {
	const typeClasses = Array.isArray(type) ? type.map(t => styles[t]) : styles[type];
	return (
		<button
			disabled={disabled}
			type="button"
			className={classNames(styles.button, typeClasses)}
			onClick={action}
		>
			{children}
		</button>
	);
};

export default Button;
